import { format } from "date-fns";
import { toast } from "react-toastify";
import api_client from "../Authentication/axiosConfig";

// Simple refresh action
export const handleRefreshClick = (fetchNewsData) => {
  fetchNewsData();
};

export const handleInstagramPublishPostClick = async (selectedArticleId, title, summary, category, llmSummary) => {
  try {
    const response = await api_client.post("/instagram/publish_post/", {
      id: selectedArticleId,
      title: title,
      summary: summary,
      category: category,
      llm_summary: llmSummary
    });


    if (response.status === 202) {
      toast.success("Instagram post & story will be published shortly!");
    } else {
      toast.warn(`Unexpected error code: ${response.status}`);
    }

  } catch (error) {
    if (error.response) {
      toast.error(`Error: ${error.response.data.message || "Something went wrong. Contact support."}`);
    } else if (error.request) {
      toast.error("No response from the server. Please try again later.");
    } else {
      toast.error("An error occurred. Please try again. If error continues, contact support.");
    }
  }
};

export const handleWordpressPublishPostClick = async (selectedArticleId, title, summary, category, llmSummary) => {
    try {
      const response = await api_client.post("/wordpress/publish_post/", {
        id: selectedArticleId,
        title: title,
        summary: summary,
        category: category,
        llm_summary: llmSummary
      });


      if (response.status === 202) {
        toast.success("Article will be published shortly!");
      } else if (response.status === 400) {
        toast.error("Invalid request. Please check the article details.");
      } else {
        toast.warn(`Unexpected error code: ${response.status}`);
      }

    } catch (error) {
      if (error.response) {
        toast.error(`Error: ${error.response.data.message || "Something went wrong. Contact support."}`);
      } else if (error.request) {
        toast.error("No response from the server. Please try again later.");
      } else {
        toast.error("An error occurred. Please try again. If error continues, contact support.");
      }
    }
  };

export const handleScheduleClick = async (selectedArticleData, setSelectedArticleData, setOpen) => {
    setSelectedArticleData(selectedArticleData);
    setOpen(true);
  };

export const handleDateChange = (date, setSelectedDate) => {
  setSelectedDate(date);
};

export const handleScheduleSubmit = async (
  selectedArticleData,
  selectedDate,
  setOpen,
  fetchNewsData
) => {
  try {
    const formattedDate = format(selectedDate, "yyyy-MM-dd'T'HH:mm:ss");

    const response = await api_client.post("/schedule_news/", {
      news_id: selectedArticleData.id,
      scheduled_time: formattedDate,
    });

    if (response.data) {
      toast.success("Successfully scheduled news.");
      setOpen(false);
      fetchNewsData();
    }
  } catch (error) {
    console.error("Error scheduling news:", error);
    toast.error("Failed to schedule news.");
  }
};

export const handleDeleteClick = async (id, fetchData) => {
    try {
      await api_client.post("/delete_news/", {
        article_id: id,
      });
      console.log(`Article with ID ${id} marked as deleted`);
      await fetchData();
    } catch (error) {
      console.error("Error marking article as deleted:", error);
    }
  };

export const handleSingleArchiveClick = async (id, fetchData) => {
    try {
      await api_client.post("/archive_article/", {
        article_id: id,
      });
      console.log(`Article with ID ${id} marked as archived`);
      await fetchData();
    } catch (error) {
      console.error("Error marking article as archived:", error);
    }
};